import { render, staticRenderFns } from "./edit-discount.vue?vue&type=template&id=a827a882&scoped=true&"
import script from "./edit-discount.vue?vue&type=script&lang=js&"
export * from "./edit-discount.vue?vue&type=script&lang=js&"
import style0 from "./edit-discount.vue?vue&type=style&index=0&id=a827a882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a827a882",
  null
  
)

export default component.exports